import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { AppUpdate } from '@capawesome/capacitor-app-update';
import styled from 'styled-components';
import { ButtonV2 } from 'src/components/general/button/lgg-button';
import { LggCircleIcon } from 'src/components/general/icon/circle-icon/lgg-circle-icon';
import { LggModal } from 'src/components/general/modals/lgg-modal';
import { FlexColumn } from 'src/components/layout/flex-column';

const StyledCircleIcon = styled(LggCircleIcon)`
  height: 90px;
  width: 90px;

  svg {
    height: 30px;
    width: 30px;
  }
`;

const ModalFooter = styled.div`
  padding: 20px;

  button {
    width: 100%;
  }
`;

const ModalContent = styled(FlexColumn)`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.koala};
  padding: 20px;
`;

const ModalTitle = styled.span`
  color: ${({ theme }) => theme.colors.darkCarbon};
  font-family: ${({ theme }) => theme.font.regular};
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: -0.48px;
  line-height: 30px;
  margin-bottom: 10px;
  margin-top: 10px;
  text-align: center;
`;

const ModalDescription = styled.span`
  color: ${({ theme }) => theme.colors.smalt};
  font-family: ${({ theme }) => theme.font.regular};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  text-align: center;
  white-space: pre-wrap;
`;

export const UpdateAppModal = memo(() => {
  const { t } = useTranslation(['common']);

  return (
    <LggModal
      visible={true}
      onClose={() => {}}
      closable={false}
      width="calc(100% - 40px)"
    >
      <ModalContent>
        <StyledCircleIcon icon="update" $bgColor="porcelain2" $iconColor="gogo" />
        <ModalTitle>{t('common:updateApp.modal.title')}</ModalTitle>
        <ModalDescription>{t('common:updateApp.modal.description')}</ModalDescription>
      </ModalContent>
      <ModalFooter>
        <ButtonV2 size="small" variant="cta" onClick={() => AppUpdate.openAppStore()}>
          {t('common:updateApp.modal.action')}
        </ButtonV2>
      </ModalFooter>
    </LggModal>
  );
});
